export default "__VITE_ASSET__Dhu1dMIc__"